module.exports = __webpack_public_path__ + "img/solution_4.ed272d78.png";